<template>
  <div>
    <c-box
      :title="'Достижение целей за ' + date.format('MMM')"
      shadow
      header-divider
      :loading="loading"
    >
      <template v-slot:header-right>
        <form class="form-inline">
          <div class="form-group">
            График
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="chart"
              >
            </label>
            Таблица
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="table"
              >
            </label>
          </div>
        </form>
      </template>

      <table
        v-if="view === 'table' && !loading && dataTableVisible.length"
        class="table"
      >
        <thead>
          <tr>
            <th>Цель</th>
            <th>Достижение цели</th>
            <th>Целевые визиты</th>
            <th>Конверсия</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item of dataTableVisible"
            :key="item.Цель"
          >
            <td v-text="item.Цель" />
            <th
              class="text-success"
              v-text="item.Достижения"
            />
            <th
              class="text-success"
              v-text="item.Визиты"
            />
            <th v-text="item.Конверсия + '%'" />
          </tr>
        </tbody>
      </table>
      <no-data v-if="view === 'table' && !loading && !dataTableVisible.length" />
      <div id="tg-g">
        <c-line-chart
          v-if="view === 'chart' && !loading && dataChartVisible.length"
          :chart-data="chartData"
          :options="chartOptions"
          :height="200"
        />
      </div>
      <no-data v-if="view === 'chart' && !loading && !dataChartVisible.length" />
    </c-box>
    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'
import CLineChart from '../../../../../../../resources/js/components/ui/CLineChart.vue'
import moment from 'moment'
import { conclusion1CToHtml } from '../../../../../../../resources/js/helper'

export default {
  name: 'TrafficGoals',
  components: { CLineChart, NoData, CBox },
  mixins: [sengine, diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    dataTable: {
      type: Array,
      required: true
    },
    dataChart: {
      type: Array,
      required: true
    },
    month: {
      type: Number,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      view: 'table',
      chartOptions: {
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        elements: {
          point: {
            radius: 3
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 7,
            fontStyle: 'bold',
            fontColor: '#282828',
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    date () {
      return moment().month(this.month)
    },
    dataTableVisible () {
      return this.dataTable.filter(i => i.НапечататьВОтчете)
    },
    dataChartVisible () {
      return this.dataChart.filter(i => i.НапечататьВОтчете)
    },
    chartData () {
      const dates = []

      for (const month in this.dataChartVisible[0]) {
        if (['Цель', 'Динамика', 'НапечататьВОтчете'].includes(month)) {
          continue
        }

        dates.push(month)
      }

      return {
        labels: dates,
        datasets: this.dataChartVisible.map((item, index) => {
          const visits = []

          for (const d in item) {
            if (Number.isInteger(item[d])) {
              visits.push(item[d])
            }
          }

          return {
            label: item.Цель,
            data: visits,
            fill: false,
            borderColor: this.getNextDiagramColor(index),
            lineTension: 0
          }
        })
      }
    },
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    }
  }
}
</script>

<style lang="scss" scoped>
  #tg-g {
    min-width: 890px;
  }
</style>
